import logo from "../assets/images/logo.png"
import short_logo from "../assets/images/short_logo.png"
import down from "../assets/ippo_icons/down.svg"

export const LOGO = logo;
export const SHORT_LOGO = short_logo;
export const DOWN = down;